var icon = require('vue-svgicon')
icon.register({
  'ionicons/ios-list-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M432 80v352H80V80h352m16-16H64v384h384V64z"/><path pid="1" d="M192 152h192v16H192zM192 248h192v16H192zM192 344h192v16H192z"/><circle pid="2" cx="144" cy="160" r="16"/><circle pid="3" cx="144" cy="256" r="16"/><circle pid="4" cx="144" cy="352" r="16"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/ionicons/ios-list-outline.js